import React from 'react';
import { createSvgIcon } from '@mui/material';

const CustomInteractionsFilled = createSvgIcon(
  <path d="M5.3 10.3c0-1.9 1.5-3.4 3.3-3.4h6.6v3.3l4.5-4.3-4.5-4.3v3.3H8.6c-2.9 0-5.3 2.4-5.3 5.4v4.3h2zm13.4-.8v4.3c0 1.9-1.5 3.4-3.3 3.4H8.8v-3.4l-4.5 4.3 4.5 4.3v-3.1h6.6c2.9 0 5.3-2.4 5.3-5.4V9.5z" />,
  'CustomInteractionsFilled',
);

export default CustomInteractionsFilled;
